var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSalesChannelsEmptyList = function SvgSalesChannelsEmptyList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 97,
    fill: "none",
    className: "svgr-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sales-channels-empty-list_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EF7C7E",
    d: "M82.03 31.126c6.56 0 11.88-5.318 11.88-11.879 0-6.56-5.32-11.878-11.88-11.878s-11.879 5.318-11.879 11.878 5.319 11.88 11.88 11.88M73.141 8.096a3.798 3.798 0 1 0 0-7.596 3.798 3.798 0 0 0 0 7.596"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2E2D9",
    d: "M12.778 89.712c6.56 0 11.879-5.318 11.879-11.879 0-6.56-5.319-11.879-11.88-11.879C6.218 65.955.9 71.274.9 77.834c0 6.56 5.318 11.878 11.879 11.878M21.667 96.58a3.798 3.798 0 1 0 0-7.595 3.798 3.798 0 0 0 0 7.596"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ED7EE",
    d: "M47.202 83.894c19.726 0 35.717-15.991 35.717-35.717S66.93 12.46 47.202 12.46 11.485 28.45 11.485 48.177s15.991 35.717 35.717 35.717"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M47.202 87.611c21.779 0 39.434-17.655 39.434-39.434 0-21.78-17.655-39.435-39.434-39.435S7.768 26.398 7.768 48.177 25.423 87.61 47.202 87.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M44.131 9.793s-16.161 7.92-15.515 39.03C29.263 79.934 43 87.37 43 87.37"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M15.202 25.55s34.182 21.091 63.192-.242M47.121 9.712V33.47M47.121 66.44v21.252M43.08 48.5H8.254M46.475 61.995s-21.253 1.374-31.111 9.697"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M49.869 9.308s11.151 3.232 15.11 25.293M53.99 76.46h34.99c1.697 0 3.232-1.212 3.394-2.91.08-.727-.081-1.535-.727-2.343-.405-.566-1.051-1.05-1.617-1.374l-2.262-1.293M96.09 41.147l1.213-4.364c.243-.727.808-1.293 1.455-1.212l9.131.242"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEE1BF",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M63.93 90.116a4.687 4.687 0 1 0 0-9.374 4.687 4.687 0 0 0 0 9.374ZM81.707 90.116a4.687 4.687 0 1 0 0-9.373 4.687 4.687 0 0 0 0 9.373Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEE1BF",
    d: "M82.192 41.47s3.475 12.444-4.849 26.02H54.717l-7.03-26.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M96.01 41.147H49.303c-1.293 0-2.263 1.292-1.94 2.505l6.061 22.14c.404 1.456 1.697 2.506 3.233 2.506h31.272z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sales-channels-empty-list_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.899.5h108.202v96H.899z"
  })))));
};
export default SvgSalesChannelsEmptyList;